import React from "react";
import MessageDashboard from "./Msg DeshBoard/MessageDashboard";
const MessageMonitor = () => {
  return (
    <div>
      <MessageDashboard />
    </div>
  );
};

export default MessageMonitor;
